module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fZleh"))).then(() => parcelRequire('1iHdE'));